import { useEffect, useState } from 'react'

type ConsentPreferencesCardProps = {
  title: string
  description: string
  mandatoryConsentLabel: string
  mandatoryConsentValue: string
  mandatoryConsentDateLabel: string
  mandatoryConsentDateValue: string
  marketingEmailLabel: string
  promotionalNotificationsLabel: string
  saveLabel: string
  saveBusyLabel: string
  marketingEmail: boolean
  promotionalNotifications: boolean
  saving: boolean
  onSave: (input: { marketingEmail: boolean; promotionalNotifications: boolean }) => void
}

export const ConsentPreferencesCard = ({
  title,
  description,
  mandatoryConsentLabel,
  mandatoryConsentValue,
  mandatoryConsentDateLabel,
  mandatoryConsentDateValue,
  marketingEmailLabel,
  promotionalNotificationsLabel,
  saveLabel,
  saveBusyLabel,
  marketingEmail,
  promotionalNotifications,
  saving,
  onSave,
}: ConsentPreferencesCardProps) => {
  const [nextMarketingEmail, setNextMarketingEmail] = useState(marketingEmail)
  const [nextPromotionalNotifications, setNextPromotionalNotifications] = useState(
    promotionalNotifications,
  )

  useEffect(() => {
    setNextMarketingEmail(marketingEmail)
  }, [marketingEmail])

  useEffect(() => {
    setNextPromotionalNotifications(promotionalNotifications)
  }, [promotionalNotifications])

  const changed =
    nextMarketingEmail !== marketingEmail ||
    nextPromotionalNotifications !== promotionalNotifications

  return (
    <section className="ca-card-shell ca-theme-transition rounded-3xl p-5">
      <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">{title}</h2>
      <p className="mt-1 text-sm text-(--color-text-secondary)">{description}</p>
      <div className="ca-theme-transition mt-4 rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-2 text-sm">
        <div className="flex items-center justify-between gap-4">
          <span className="text-(--color-text-muted)">{mandatoryConsentLabel}</span>
          <span className="font-semibold text-(--color-text-primary)">{mandatoryConsentValue}</span>
        </div>
        <div className="mt-1 flex items-center justify-between gap-4">
          <span className="text-(--color-text-muted)">{mandatoryConsentDateLabel}</span>
          <span className="font-semibold text-(--color-text-primary)">{mandatoryConsentDateValue}</span>
        </div>
      </div>
      <div className="mt-4 space-y-3">
        <label className="flex items-start gap-3 text-sm text-(--color-text-secondary)">
          <input
            type="checkbox"
            checked={nextMarketingEmail}
            onChange={(event) => setNextMarketingEmail(event.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-(--color-border-default) text-(--color-action-primary) focus:ring-(--color-focus-ring)"
          />
          <span>{marketingEmailLabel}</span>
        </label>
        <label className="flex items-start gap-3 text-sm text-(--color-text-secondary)">
          <input
            type="checkbox"
            checked={nextPromotionalNotifications}
            onChange={(event) => setNextPromotionalNotifications(event.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-(--color-border-default) text-(--color-action-primary) focus:ring-(--color-focus-ring)"
          />
          <span>{promotionalNotificationsLabel}</span>
        </label>
      </div>
      <button
        type="button"
        onClick={() =>
          onSave({
            marketingEmail: nextMarketingEmail,
            promotionalNotifications: nextPromotionalNotifications,
          })
        }
        disabled={saving || !changed}
        className="ca-btn-primary mt-4 inline-flex h-9 items-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
      >
        {saving ? saveBusyLabel : saveLabel}
      </button>
    </section>
  )
}
